import { BehaviorSubject } from "rxjs";
import { authService } from ".";
import { InternalInvoice } from "@/models/internal-invoice";
import { BillingPreview } from "@/models/billing-preview";

export class BillingService {
  invoices = new BehaviorSubject<InternalInvoice[]>([]);
  preview = new BehaviorSubject<BillingPreview | null>(null);
  // filters = new BehaviorSubject<InvoiceFilters>(new InvoiceFilters());
  isFetching = new BehaviorSubject(false);
  isFetchingPreview = new BehaviorSubject(false);
  pageLoaded = [0];
  page = 0;
  limit = 10;

  dispose = async () => {
    this.invoices.next([]);
    this.preview.next(null);
    // this.filters.next(new InvoiceFilters());
    this.page = 0;
    this.isFetchingPreview.next(false);
  };

  disposePreview = () => {
    this.preview.next(null);
    this.isFetchingPreview.next(false);
  };


  getInvoices = async () => {
    const invoices = await this._getInvoices(0, this.limit);
    if (invoices) {
      this.pageLoaded = [0];
      this.invoices.next(invoices);
    }
  };

  getPreview = async () => {
    try {
      this.isFetchingPreview.next(true);
      const response = await authService.authFetch("/billing/preview", {
        method: "GET",
        cache: "no-store",
      });
      if (response?.ok) {
        const data = await response.json();
        if (data) {
          const preview = Object.assign(new BillingPreview(), data);
          preview.items = data.items ?? [];
          this.preview.next(preview);
        } else {
          this.preview.next(null);
        }
      } else {
        this.preview.next(null);
      }
    } catch (e) {
      console.log(e);
      this.preview.next(null);
    } finally {
      this.isFetchingPreview.next(false);
    }
  };

  _getInvoices = async (
    page: number,
    limit: number,
    savePage: boolean = true
  ) => {
    try {
      this.isFetching.next(true);
      const response = await authService.authFetch(
        `/billing/invoices?page=${page}&limit=${limit}`,
        {
          method: "POST",
          // body: JSON.stringify(this.filters.value),
        }
      );
      if (response?.ok) {
        const invoices = ((await response.json()) as InternalInvoice[]).map((invoice) =>
          Object.assign(new InternalInvoice(), invoice)
        );
        if (savePage && invoices.length > 0) {
          this.page = page;
        }
        return invoices;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.isFetching.next(false);
    }
    return null;
  };

}
